/* eslint-disable */
import { Button, Heading4, Text, useToast } from '@serodigital/ui-components';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { generateHotWaterSchedules, IZoneArray } from '../../helpers/scheduleHelper';
import { ZonesList } from './zones';
import { IZone } from '../../views/bee/state/types';
import { HotWaterSchedulesResponse } from '../../../../shared/api-clients/gql';
import { HotWaterScheduleModal, ISelectedSchedule } from './hotWaterScheduleModal';

interface IScheduleProps {
  title: string;
  schedules: HotWaterSchedulesResponse;
}

export function HotWaterSchedule({ title, schedules}: IScheduleProps) {
  const [scheduleItems, setScheduleItems] = useState<IZoneArray>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState<ISelectedSchedule>(null);
  const { setToastMessage } = useToast();

  useEffect(() => {
    if (!schedules) return;
    const { setpoints } = generateHotWaterSchedules(schedules);
    setScheduleItems(setpoints);
  }, [schedules]);

  function onAddSchedule() {
    setIsModalOpen(true);
  }
  const hasSchedules = scheduleItems?.hot_water && Object.keys(scheduleItems.hot_water).length > 0;

  function handleCloseModal(message?: string) {
    setSelectedSchedule(null);
    setIsModalOpen(false);
    if (typeof message === 'string') {
      setToastMessage({ label: message, type: 'success', position: 'topCenter' });
    }
  }

  function onClickSchedule(schedule: ISelectedSchedule) {
    setSelectedSchedule(schedule);
    setIsModalOpen(true);
  }

  return (
    <div data-qa="hot-water-schedules" className="w-full flex flex-col rounded-xl border border-grey-neutral p-20 ">
      <div className="flex flex-row justify-between">
        <Heading4 className="p-0 m-0">{title}</Heading4>
        {hasSchedules && (
          <Button data-qa="add-schedule-btn" onClick={onAddSchedule} kind="primary">
            Add another schedule
          </Button>
        )}
      </div>
      {!hasSchedules ? (
        <div className="flex items-center justify-center h-160 flex-col space-y-16">
          <Text>To get started add your first schedule</Text>
          <Button data-qa="new-schedule-btn" onClick={onAddSchedule} kind="primary">
            Add a schedule
          </Button>
        </div>
      ) : (
        <div>
          <ZonesList
            key={'hot_water'}
            zoneId={'hot_water'}
            zoneName={'Hot Water Times'}
            zones={scheduleItems['hot_water'].map(item => {
              return {
                start: item.start,
                day: item.day,
              };
            })}
            onClickSchedule={onClickSchedule}
          />
        </div>
      )}

      {isModalOpen && (
        <HotWaterScheduleModal
          title={'Hot Water - Add Days And Time'}
          isOpen={isModalOpen}
          zoneSchedules={scheduleItems}
          handleCloseModal={handleCloseModal}
          selectedSchedule={selectedSchedule}
        />
      )}
    </div>
  );
}
